import React from 'react';
import ResetPassword from '../section/loginpage/ResetPassword';

export default function ResetPasswordPage() {
  return (
    <div>
      <ResetPassword />
    </div>
  );
}
